import { Device } from 'src/Libs/flow/installation/forms'
import { PairingState } from 'src/Libs/flow/installation/api/installations'

type OverviewDevice = Pick<Device, 'deviceCategory'> & { serialNumber: string | null; pairingState?: PairingState }

export type PlannedDeviceStatus = 'notConnected' | 'notPaired' | 'online' | 'offline'

export const getPlannedDeviceStatus = (device: OverviewDevice, emc: OverviewDevice | undefined, isEmcOnline: boolean): PlannedDeviceStatus => {
  const isEmcConnected = !!emc?.serialNumber && emc.serialNumber !== '-'

  if (device.deviceCategory === 'EMC' && !isEmcConnected) return 'notConnected'
  if (device.deviceCategory === 'Meter' && (device.pairingState !== 'paired' || !device.serialNumber || device.serialNumber === '-'))
    return 'notPaired'

  return !isEmcOnline ? 'offline' : 'online'
}
